import React, { useMemo } from 'react';
import { useEditMode } from '../../../shared/hooks/useEditMode';
import { useProjectElementListStore } from '../../../shared/store/projectElementStore';
import { SelectType, DisplayAlignment, DisplaySize, ImageStyle, DetailType, normalizePEInfoType, PEInfoType } from '../../../shared/enum/EnumRepository';
import { WorkDetailData } from '../../../shared/dto/EntityRepository';
import SelectBox from '../../../shared/component/SelectBox';
import { useImageStyleJudge } from '../../../shared/hooks/useImageStyleJudge';
import DetailInfo from '../DetailInfo';
import DetailImgInPeMobile from './DetailImgInPeMobile';
import DetailVideoInPeMobile from './DetailVideoInPeMobile';
import { PEImgContentWrapper, PEHeader, PEIndicator, SelectBoxContainer, SelectBoxWrapper, ImgContentCoreWrapper, ImgWrapper } from './WorkMobile';

export interface DetailMobileProps {
  peId: string;
  alignment: DisplayAlignment;
  displaySize: DisplaySize;
  infoType?: PEInfoType;
  data: WorkDetailData;
  priority: boolean;
}

const DetailMobile: React.FC<DetailMobileProps> = ({ peId, alignment, displaySize, infoType, data, priority }) => {
  const { isEditMode } = useEditMode();
  const handleDisplaySizeChange = useProjectElementListStore((s) => s.updateDisplaySize);
  const handleInfoTypeChange = useProjectElementListStore((s) => s.updateInfoType);
  const { judgeImageStyle } = useImageStyleJudge();
  const imageStyle = useMemo(() => judgeImageStyle(data.uploadFile?.width / data.uploadFile?.height), [data.uploadFile?.width, data.uploadFile?.height]);
  const effectiveInfoType = normalizePEInfoType(infoType);

  return (
    <PEImgContentWrapper>
      {isEditMode &&
        <PEHeader>
          <SelectBoxContainer>
            <SelectBoxWrapper>
              <SelectBox
                value={displaySize || DisplaySize.BIG}
                selectType={SelectType.WORK_SIZE}
                handleChange={(value) => handleDisplaySizeChange(peId, value)}
                direction={false} />
            </SelectBoxWrapper>
            <SelectBoxWrapper>
              <SelectBox
                value={effectiveInfoType}
                selectType={SelectType.PE_INFO_TYPE}
                handleChange={(value) => handleInfoTypeChange(peId, value)}
                direction={false} />
            </SelectBoxWrapper>
          </SelectBoxContainer>
          <PEIndicator peId={peId}>: Detail Cut</PEIndicator>
        </PEHeader>
      }
      <ImgContentCoreWrapper>
        <ImgWrapper>
          {data.detailType === DetailType.VIDEO ? (
            <DetailVideoInPeMobile
              peId={peId}
              alignment={DisplayAlignment.CENTER}
              displaySize={displaySize || DisplaySize.BIG}
              data={data}
              priority={priority}
            />
          ) : (
            <DetailImgInPeMobile
              peId={peId}
              alignment={DisplayAlignment.CENTER}
              displaySize={displaySize || DisplaySize.BIG}
              data={data}
              priority={priority}
            />
          )}
        </ImgWrapper>
        <DetailInfo
          peId={peId}
          alignment={alignment || DisplayAlignment.CENTER}
          displaySize={displaySize || DisplaySize.BIG}
          imageStyle={imageStyle || ImageStyle.LANDSCAPE}
          infoType={effectiveInfoType}
          data={data} />
      </ImgContentCoreWrapper>
    </PEImgContentWrapper>
  );
};

export default DetailMobile;
